import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../Components/adminComponents/Sidebar";
import { FiHome } from "react-icons/fi";
import { MdLogout } from "react-icons/md";

const DashboardLayout = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen grid">
      <div className="flex items-start justify-start">
        <Sidebar />
        <div className="bg-gray-50 flex-1 min-h-screen">
          <header
            className="h-14 flex items-center justify-between border-b-2 px-4 shadow-lg"
            aria-label="Admin dashboard header"
          >
            <span className="font-semibold text-transparent bg-clip-text bg-gradient-to-r from-[#064585] via-[#5989C8] to-[#64a2ff]">
              Hello, Manas
            </span>

            <div className="flex gap-3">
              <button
                className="p-2 cursor-pointer rounded-full bg-gradient-to-r from-[#064585] to-[#64a2ff] text-white"
                onClick={() => navigate("/")}
              >
                <FiHome size={25} />
              </button>
              <button
                className="p-2 cursor-pointer rounded-full bg-gradient-to-r from-[#064585] to-[#64a2ff] text-white"
                onClick={() => navigate("/")}
              >
                <MdLogout size={25} />
              </button>
            </div>
          </header>

          <main role="main" className="bg-slate-100 h-[92vh] overflow-y-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
